<template>
  <div class="max-w-6xl h-full m-auto py-2 px-4 flex flex-col">
    <h2 class="py-4 text-2xl">Available Inventory</h2>
    <div class="py-4 flex flex-row relative">
      <form v-on:submit.prevent="getAvailableInventory">
        <div class="flex rounded-md shadow-sm">
          <div class="relative flex items-stretch flex-grow focus-within:z-10">
            <div
              class="absolute inset-y-0 left-0 pl-0 flex items-center focus:outline-none outline-none"
            >
              <select
                v-model="searchType"
                @change="focusSearch"
                aria-label="searchType"
                class="pt-1.5 text-gray-400 form-select h-full border-transparent bg-transparent focus:border-transparent focus:shadow-none"
              >
                <option value="LocalSKU">SKU</option>
                <option value="ItemName">Product</option>
              </select>
            </div>

            <input
              id="search"
              ref="quickSearch"
              class="p-1 form-input block w-full pl-28"
              v-model="searchValue"
            />
          </div>
          <Button
            class="btn relative z-10 ml-3"
            v-on:click-handler="getAvailableInventory"
            :disabled="!canSearch"
            >Search
            <loading-spinner v-if="searching" class="w-4 h-4 text-white ml-2" />
          </Button>
        </div>
      </form>
    </div>
    <ag-grid-vue
      style="height: 100%; width: 100%"
      class="ag-theme-balham"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :paginationAutoPageSize="false"
      :paginationPageSize="paginationPageSize"
      :pagination="true"
      id="inventory-available"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :context="context"
      :frameworkComponents="frameworkComponents"
      :defaultColDef="defaultColDef"
      :enableCellTextSelection="true"
      :ensureDomOrder="true"
    >
    </ag-grid-vue>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { ApiFactory } from "@/api/ApiFactory.js";
import OnOrderLink from "./components/OnOrderLink";
import QuantityOnHandLink from "./components/QuantityOnHandLink";
import ShopifyFGTLink from "./components/ShopifyFGTLink";
import ShopifyBBLink from "./components/ShopifyBBLink";
import Button from "@/components/elements/Button";

const InventoriesApi = ApiFactory.get("inventories");

export default {
  name: "InventoryAvailable",
  components: {
    Button,
    AgGridVue,
    ShopifyFGTLink, // eslint-disable-line
    ShopifyBBLink, // eslint-disable-line
    OnOrderLink, // eslint-disable-line
    QuantityOnHandLink, // eslint-disable-line
  },
  props: {},
  data() {
    return {
      columnDefs: null,
      rowData: [],
      paginationPageSize: 100,
      frameworkComponents: null,
      gridApi: null,
      columnApi: null,
      gridOptions: null,
      context: null,
      defaultColDef: null,
      overlayLoadingTemplate: true,
      searchType: "LocalSKU",
      searchValue: null,
      searching: false,
    };
  },
  computed: {
    canSearch() {
      return !this.searching;
    },
  },
  async created() {
    const response = await ApiFactory.get("feature-flags").isFeatureFlagEnabled("phase3d_care_app");

    if (response.status == 200) {
      if (response.data.body.enabled) {
        await this.$router.push({ name: "Dashboard" });
      }
    }
  },
  async beforeMount() {
    this.gridOptions = {};

    this.context = { componentParent: this };

    this.defaultColDef = {
      sortable: true,
      filter: true,
      suppressMovable: true,
      maxWidth: 100,
    };

    this.columnDefs = [
      {
        headerName: "SKU",
        field: "LocalSKU",
        minWidth: 150,
      },
      {
        headerName: "ParentID",
        field: "ParentID",
      },
      {
        headerName: "Name",
        field: "ItemName",
        minWidth: 200,
      },
      {
        headerName: "Committed",
        field: "Committed",
      },
      {
        headerName: "Sellable",
        field: "true_qoh",
      },
      {
        headerName: "Back Order",
        field: "Backordered",
      },
      {
        headerName: "On Order",
        field: "OnOrder",
        cellRendererFramework: "OnOrderLink",
      },
      {
        headerName: "Growing",
        field: "Growing",
      },
      {
        headerName: "FGT",
        field: "Shopify.FGT",
        cellRendererFramework: "ShopifyFGTLink",
      },
      {
        headerName: "BB",
        field: "Shopify.BB",
        cellRendererFramework: "ShopifyBBLink",
      },
    ];
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getAvailableInventory() {
      this.searching = true;
      this.gridApi.showLoadingOverlay();

      InventoriesApi.available({
        drop_ship: false,
        available_for_sale: true,
        searchType: this.searchType,
        searchValue: this.searchValue,
      }).then((response) => {
        this.rowData = response.data.body.map((row) => {
          return {
            LocalSKU: row.LocalSKU,
            ParentID: row.ParentID,
            ItemName: row.ItemName,
            Committed: row.Committed,
            true_qoh: row.true_qoh ?? 0,
            Backordered: row.Backordered,
            OnOrder: row.OnOrder,
            Growing: row.Growing,
            Active_FGT: row.Active_FGT,
            Active_BB: row.Active_BB,
            Shopify: row.Shopify,
          };
        });
        this.searching = false;
      });
    },
    focusSearch() {
      this.$refs.quickSearch.focus();
    },
    onGridReady() {},
  },
  filters: {},
};
</script>
<style lang="scss">
@import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>
